(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initializeSupermeeProduct(section) {
    if (!section || section.dataset.productInitialized === 'true') {
      return;
    }

    section.dataset.productInitialized = 'true';

    const variantSelect = section.querySelector(
      '[data-product-variant-select]'
    );

    const submitButton = section.querySelector(
      '[data-product-submit]'
    );

    const submitText = section.querySelector(
      '[data-product-submit-text]'
    );

    const priceElement = section.querySelector(
      '[data-product-price]'
    );

    const comparePriceElement = section.querySelector(
      '[data-product-compare-price]'
    );

    const inventoryElement = section.querySelector(
      '[data-product-inventory]'
    );

    const skuWrapper = section.querySelector(
      '[data-product-sku-wrapper]'
    );

    const skuElement = section.querySelector(
      '[data-product-sku]'
    );

    const mainImage = section.querySelector(
      '.supermee-product__image'
    );

    const saleBadge = section.querySelector(
      '[data-product-sale-badge]'
    );

    const soldBadge = section.querySelector(
      '[data-product-sold-badge]'
    );

    const quantityInput = section.querySelector(
      '[data-quantity-input]'
    );

    const quantityMinus = section.querySelector(
      '[data-quantity-minus]'
    );

    const quantityPlus = section.querySelector(
      '[data-quantity-plus]'
    );

    const thumbnails = section.querySelectorAll(
      '[data-product-thumbnail]'
    );

    const shareButton = section.querySelector(
      '[data-product-share]'
    );

    const shareMessage = section.querySelector(
      '[data-product-share-message]'
    );

    const addLabel = section.dataset.addLabel || 'Add to cart';
    const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';
    const inStockLabel = section.dataset.inStockLabel || 'In stock';
    const lowStockTemplate =
      section.dataset.lowStockLabel || 'Only [quantity] left';
    const preorderLabel =
      section.dataset.preorderLabel || 'Available for preorder';

    const lowStockThreshold = Number(
      section.dataset.lowStockThreshold || 5
    );

    function setActiveThumbnail(mediaId) {
      if (!mediaId) {
        return;
      }

      thumbnails.forEach((thumbnail) => {
        const isActive =
          String(thumbnail.dataset.mediaId) === String(mediaId);

        thumbnail.classList.toggle(
          'supermee-product__thumbnail--active',
          isActive
        );

        thumbnail.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });
    }

    function updateMainImage(url, alt, mediaId) {
      if (!mainImage || !url) {
        return;
      }

      mainImage.removeAttribute('srcset');
      mainImage.src = url;

      if (alt) {
        mainImage.alt = alt;
      }

      setActiveThumbnail(mediaId);
    }

    function updateVariant() {
      if (!variantSelect) {
        return;
      }

      const option =
        variantSelect.options[variantSelect.selectedIndex];

      if (!option) {
        return;
      }

      const isAvailable = option.dataset.available === 'true';
      const price = option.dataset.price || '';
      const comparePrice = option.dataset.comparePrice.trim();
      const sku = option.dataset.sku || '';
      const inventory = Number(option.dataset.inventory || 0);
      const inventoryManagement =
        option.dataset.inventoryManagement || '';
      const inventoryPolicy =
        option.dataset.inventoryPolicy || '';
      const imageUrl = option.dataset.imageUrl.trim();
      const imageAlt = option.dataset.imageAlt.trim();
      const imageId = option.dataset.imageId.trim();

      if (priceElement) {
        priceElement.textContent = price;
      }

      if (comparePriceElement) {
        if (comparePrice) {
          comparePriceElement.textContent = comparePrice;
          comparePriceElement.hidden = false;
        } else {
          comparePriceElement.textContent = '';
          comparePriceElement.hidden = true;
        }
      }

      if (saleBadge) {
        saleBadge.hidden = !comparePrice;
      }

      if (soldBadge) {
        soldBadge.hidden = isAvailable;
      }

      if (submitButton) {
        submitButton.disabled = !isAvailable;
      }

      if (submitText) {
        submitText.textContent = isAvailable
          ? addLabel
          : soldOutLabel;
      }

      if (skuWrapper && skuElement) {
        skuElement.textContent = sku;
        skuWrapper.hidden = !sku;
      }

      if (inventoryElement) {
        inventoryElement.classList.toggle(
          'supermee-product__inventory--sold',
          !isAvailable
        );

        if (!isAvailable) {
          inventoryElement.textContent = soldOutLabel;
        } else if (
          inventoryManagement &&
          inventory > 0 &&
          inventory <= lowStockThreshold
        ) {
          inventoryElement.textContent =
            lowStockTemplate.replace(
              '[quantity]',
              String(inventory)
            );
        } else if (
          inventoryManagement &&
          inventory <= 0 &&
          inventoryPolicy === 'continue'
        ) {
          inventoryElement.textContent = preorderLabel;
        } else {
          inventoryElement.textContent = inStockLabel;
        }
      }

      if (imageUrl) {
        updateMainImage(
          imageUrl,
          imageAlt,
          imageId
        );
      }

      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', option.value);

      window.history.replaceState(
        {},
        '',
        variantUrl.toString()
      );
    }

    if (variantSelect) {
      variantSelect.addEventListener(
        'change',
        updateVariant
      );
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        updateMainImage(
          thumbnail.dataset.imageSrc,
          thumbnail.dataset.imageAlt,
          thumbnail.dataset.mediaId
        );
      });
    });

    if (quantityMinus && quantityInput) {
      quantityMinus.addEventListener('click', () => {
        const currentValue = Number(quantityInput.value || 1);

        quantityInput.value = Math.max(
          1,
          currentValue - 1
        );

        quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }

    if (quantityPlus && quantityInput) {
      quantityPlus.addEventListener('click', () => {
        const currentValue = Number(quantityInput.value || 1);

        quantityInput.value = currentValue + 1;

        quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        const currentValue = Number(quantityInput.value || 1);

        quantityInput.value = Math.max(
          1,
          currentValue
        );
      });
    }

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const successText =
          shareButton.dataset.shareSuccess ||
          'Product link copied.';

        try {
          if (navigator.share) {
            await navigator.share({
              title: document.title,
              url: window.location.href
            });
          } else {
            await navigator.clipboard.writeText(
              window.location.href
            );

            if (shareMessage) {
              shareMessage.textContent = successText;
              shareMessage.hidden = false;

              window.setTimeout(() => {
                shareMessage.hidden = true;
              }, 2500);
            }
          }
        } catch (error) {
          return;
        }
      });
    }
  }

  function initializeAllSupermeeProducts(container) {
    const scope = container || document;

    scope
      .querySelectorAll('[data-product-section]')
      .forEach(initializeSupermeeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAllSupermeeProducts(document)
    );
  } else {
    initializeAllSupermeeProducts(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllSupermeeProducts(event.target);
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermee-value-strip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.supermee-value-strip');

    sections.forEach(function (section) {
      const topBorder = section.getAttribute('data-show-top-border');
      const bottomBorder = section.getAttribute('data-show-bottom-border');

      if (topBorder === 'true') {
        section.setAttribute('data-top-border', 'true');
      }

      if (bottomBorder === 'true') {
        section.setAttribute('data-bottom-border', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
